import _baseProperty from "./_baseProperty";
var exports = {};
var baseProperty = _baseProperty;

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty("length");
exports = asciiSize;
export default exports;